module.exports = __webpack_public_path__ + "static/media/22.182e3117.jpg";